module.exports = __webpack_public_path__ + "media/images/stat__background-c0a695fe0a51cf93ca3e71bee7b6bab5.jpg";